<script lang="ts">
  import Thumbnail from './Thumbnail.svelte';
  import PictureOverlay from './PictureOverlay.svelte';
  import { type ImageType } from "@briefmarken_katalog/types";
  import { t } from "$lib/i18n";
  
  let { picture, fetchFullImage }: { picture: ImageType | undefined; fetchFullImage?: () => Promise<ImageType | undefined> } = $props();

  let isOverlayOpen = $state(false);
  let imageSrc = $state<string | undefined>(undefined);

  async function onOpenFullImage() {
    const img = fetchFullImage ? await fetchFullImage() : picture;
    imageSrc = img?.base64 || img?.thumbnail;
    isOverlayOpen = true;
  }
</script>

{#if picture}
<Thumbnail
  {picture}
  {onOpenFullImage}
/>

<PictureOverlay
  src={imageSrc}
  alt={$t('alt.aStamp')}
  bind:open={isOverlayOpen}
/>
{/if}